import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Navbar.css";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [navbarOpen, setNavbarOpen] = useState(false);

const location = useLocation();
let complianceProduct = "ppi";

if (location.pathname.startsWith("/tapay")) {
  complianceProduct = "paymentgateway";
} else if (location.pathname.startsWith("/citizen-wallet")) {
  complianceProduct = "ppi";
} else if (location.pathname.startsWith("/bbps-services")) {
  complianceProduct = "bbps";
} else if (location.pathname.startsWith("/onboarding-stack")) {
  complianceProduct = "onboarding";
}
  const isHomePage = location.pathname === "/";
  const isCareerPage = location.pathname === "/career";
    const isContactusPage = location.pathname === "/contactus";

  const isOrganizationPage =
    location.pathname.startsWith("/aboutus") ||
    location.pathname.startsWith("/boardmembers") ||
    location.pathname.startsWith("/senior-management");

  const isHomeProductPage =
    location.pathname.startsWith("/tapay") ||
    location.pathname.startsWith("/citizen-wallet") ||
    location.pathname.startsWith("/bbps-services") ||
    location.pathname.startsWith("/onboarding-stack");

  const showMainMenu = isHomePage || isCareerPage || isContactusPage || isOrganizationPage;

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (!mobile) {
        setActiveMenu(null);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleNavbar = () => setNavbarOpen(!navbarOpen);

  const toggleSubMenu = (menu) => {
    if (isMobile) {
      setActiveMenu((prev) => (prev === menu ? null : menu));
    }
  };

  const renderMegaMenuContent = (menu) => {
    let heading = "";
    let links = [];
    let rightPanelItems = [];

    if (menu === "Organization") {
      heading = "Organization";

      links = [
        { label: "About Us", href: "/aboutus" },
        // { label: "Contact Us", href: "/contactus" },
         { label: "Board Members", href: "/boardmembers" },
      ];

      rightPanelItems = [

        { label: "Senior Management", href: "/senior-management" },
      ];
    }

    else if (menu === "products") {
      heading = "Products";

      links = [
        { label: "Payment Aggregation Service", href: "/tapay" },
        { label: "PPI Buisness", href: "/citizen-wallet" },
      ];

      rightPanelItems = [
        { label: "BBPS Buisness", href: "/bbps-services" },
        { label: "Onboarding Stack", href: "/onboarding-stack" },
      ];
    }

    return (
      <div className={`container py-4 ${isMobile ? "" : "row"}`}>
        <div className={isMobile ? "" : "col-md-4"}>
          <h4 className="fw-bold mb-3 menus-heading">{heading}</h4>
        </div>

        <div className={isMobile ? "" : "col-md-4"}>
          <div className="action-panel">
            {links.map((link, idx) => (
              <a
                key={idx}
                href={link.href}
                className="action-item d-flex justify-content-between align-items-center"
              >
                <span>{link.label}</span>
                <i className="bi bi-arrow-right-circle-fill text-success"></i>
              </a>
            ))}
          </div>
        </div>

        <div className={isMobile ? "" : "col-md-4"}>
          <div className="action-panel">
            {rightPanelItems.map((item, idx) => (
              <a
                key={idx}
                href={item.href}
                className="action-item d-flex justify-content-between align-items-center"
              >
                <span>{item.label}</span>
                <i className="bi bi-arrow-right-circle-fill text-success"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <nav className="navbar navbar-expand-lg shadow-sm bg-white p-0 position-relative">
      <div className="container">

        <a className="navbar-brand" href="/">
          <img
            src="/assets/images/TransactionAnalysts.png"
            alt="Logo"
            className="img-fluid"
            style={{ height: "70px", marginRight: "20px" }}
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${navbarOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto gap-4">

            {/* MAIN MENU (HOME / CAREER / ORGANIZATION PAGES) */}
            {showMainMenu && (
              <>
              <li className="nav-item">
  <a className={`nav-link ${location.pathname === "/" ? "active-link" : ""}`} href="/">
    Home
  </a>
</li>
                {[ "products","Organization"].map((menu) => (
                  <li
                    key={menu}
                    className="nav-item"
                    onMouseEnter={() => !isMobile && setActiveMenu(menu)}
                  >
                    <a
                      className="nav-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSubMenu(menu);
                      }}
                    >
                      {menu.charAt(0).toUpperCase() + menu.slice(1)}
                      <i
                        className={`bi ms-1 ${
                          activeMenu === menu
                            ? "bi-chevron-up"
                            : "bi-chevron-down"
                        }`}
                      ></i>
                    </a>

                    {isMobile && activeMenu === menu && (
                      <div className="mobile-submenu px-3">
                        {renderMegaMenuContent(menu)}
                      </div>
                    )}
                  </li>
                ))}

              
            <li className="nav-item">
  <a className={`nav-link ${location.pathname === "/career" ? "active-link" : ""}`} href="/career">
    Careers
  </a>
</li>
<li className="nav-item">
  <a className={`nav-link ${location.pathname === "/contactus" ? "active-link" : ""}`} href="/contactus">
    Contact Us
  </a>
</li>

              </>
            )}

           {isHomeProductPage && (
  <>
   <li className="nav-item">
  <a className={`nav-link ${location.pathname === "/" ? "active-link" : ""}`} href="/">
    Home
  </a>
</li>
    <li
      className="nav-item"
      onMouseEnter={() => !isMobile && setActiveMenu("products")}
    >
      <a
        className="nav-link"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          toggleSubMenu("products");
        }}
      >
        Products
        <i
          className={`bi ms-1 ${
            activeMenu === "products"
              ? "bi-chevron-up"
              : "bi-chevron-down"
          }`}
        ></i>
      </a>

      {/* Mobile submenu */}
      {isMobile && activeMenu === "products" && (
        <div className="mobile-submenu px-3">
          {renderMegaMenuContent("products")}
        </div>
      )}
    </li>

      <li className="nav-item">
  <a
    className={`nav-link ${location.pathname.startsWith("/compliance-center") ? "active-link" : ""}`}
    href={`/compliance-center?product=${complianceProduct}`}
  >
    Compliance Center
  </a>
  
</li>
 {/* ✅ ALWAYS VISIBLE CONTACT US */}
  <li className="nav-item">
    <a
      className={`nav-link ${
        location.pathname === "/contactus" ? "active-link" : ""
      }`}
      href="/contactus"
    >
      Contact Us
    </a>
  </li>
              </>
            )}

          </ul>
        </div>
      </div>

      {/* Desktop Mega Menu */}
      {!isMobile && activeMenu && (
        <div
          className="services-mega-menu border-top"
          onMouseLeave={() => setActiveMenu(null)}
        >
          {renderMegaMenuContent(activeMenu)}
        </div>
      )}
    </nav>
  );
};

export default Navbar;